import { render, staticRenderFns } from "./PeriodicityList.vue?vue&type=template&id=5e79e2a6"
import script from "./PeriodicityList.vue?vue&type=script&lang=js"
export * from "./PeriodicityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports